
import type { NonsecureService } from 'commercial-web-client-utilities/dist/composables/nonsecure-service';
import type { AxiosResponse } from 'axios';
import type { TermsConditionsResponse } from '@/types';

export interface AemService {
    getTermsConditions(options: SiteSelectorData): Promise<AxiosResponse<TermsConditionsResponse>>;
}

export interface SiteSelectorData {
    businessSector?: string;
    clientNumber?: string;
    subClientNumber?: string;
    cesGroupNumber?: string;
    site?: string;
    language?: string;
}

export interface CreateAemServiceOptions {
    nonsecureService: NonsecureService;
}

function generateSiteIdentifierSelectors(options: SiteSelectorData) {
    const selectors: string[] = [];
    if (options.businessSector) {
        selectors.push('bs=' + encodeURIComponent(options.businessSector));
    }
    if (options.clientNumber) {
        selectors.push('cn=' + encodeURIComponent(options.clientNumber));
    }
    if (options.subClientNumber) {
        selectors.push('scn=' + encodeURIComponent(options.subClientNumber));
    }
    if (options.cesGroupNumber) {
        selectors.push('gn=' + encodeURIComponent(options.cesGroupNumber));
    }
    if (options.site) {
        selectors.push('site=' + encodeURIComponent(options.site));
    }
    if (options.language) {
        selectors.push('lg=' + encodeURIComponent(options.language));
    }
    return selectors.join('.');
}

/**
 * Creates service for retrieving content from AEM
 * @param serviceOptions {CreateAemServiceOptions}
 * @returns AemService
 */
export function createAemService(
    serviceOptions: CreateAemServiceOptions
): AemService {
    const {
        nonsecureService,
    } = serviceOptions;

    const nonsecureClient = nonsecureService.client;

    async function getTermsConditions(options: SiteSelectorData): Promise<AxiosResponse<TermsConditionsResponse>> {
        const selectors = generateSiteIdentifierSelectors(options);
        return await nonsecureClient.get(
            `/bin/commercial-web-my-health-toolkit/login-terms-conditions.${selectors}.json`
        );
    }

    return {
        getTermsConditions,
    };
}